export default "__VITE_ASSET__33434137__"